/* Tva sma moduler i en fil, enligt din regel att block under 2 kB gzip slas
   ihop i stallet for att tas ett och ett.

   1. on-size-calc  lag inline i snippets/on-size-calc.liquid och renderades TRE
      ganger per produktsida (storleksguiden plus mini-guidens tva instanser).
   2. on-free-shipping-bar lag inline och renderades tva ganger.

   Flytten rattar ocksa en latent bugg: raden
       var out = (format || '{{amount}}')
   stod i en .liquid-fil, sa Liquid gjorde platshallaren till en TOM strang i
   den levererade sidan, pa bada temana. Prisfallbacken gav darfor tom text om
   Shopify.formatMoney saknades. Har overlever den som text. */

(function () {
    if (window.onSizeCalc) return;

    /* Största talet i en cell. En cell kan innehålla "82-86" eller "82 (92)",
       och det är det övre värdet som avgör om måttet ryms. */
    function maxNum(s) {
      var m = ('' + (s == null ? '' : s)).match(/\d+([.,]\d+)?/g);
      if (!m) return NaN;
      var mx = -Infinity;
      m.forEach(function (x) {
        var n = parseFloat(x.replace(',', '.'));
        if (n > mx) mx = n;
      });
      return mx;
    }

    /* Samma faktor som guiden och tabellen använt sedan v2. Ändras den här
       ändras den överallt, vilket är hela skälet att filen finns. */
    var TUM = 0.3937;

    function toInch(s) {
      return String(s).replace(/\d+([.,]\d+)?/g, function (m) {
        return (parseFloat(m.replace(',', '.')) * TUM).toFixed(1);
      });
    }

    /* Minsta storlek där ALLA angivna mått ryms. Varje mått pekar ut den första
       raden vars värde når upp till måttet; svaret är den största av de raderna,
       eftersom plagget måste rymma alla mått samtidigt. */
    function rekommendera(rader, matt, val) {
      val = val || {};
      var tumTillCm = val.tum_till_cm === true;
      var stretchTak = val.anvand_stretch_tak === true;

      var maxIdx = -1;
      var nagot = false;
      var forStor = false;

      (matt || []).forEach(function (m) {
        if (!m || m.varde == null || m.varde === '') return;
        var v = parseFloat(('' + m.varde).replace(',', '.'));
        if (isNaN(v)) return;
        if (tumTillCm) v = v / TUM;
        nagot = true;

        var hittad = -1;
        for (var r = 0; r < rader.length; r++) {
          var cv = rader[r].vals ? rader[r].vals[m.idx] : NaN;
          if (!isNaN(cv) && cv >= v) {
            hittad = r;
            break;
          }
        }

        /* Utsträckt midja används BARA som tak, aldrig för att föreslå en mindre
           storlek. Att peka på den minsta storlek vars stretchade midja "täcker"
           måttet vore dåligt råd: ett plagg buret vid sin yttersta töjning sitter
           inte bra. Ligger måttet över även största storlekens utsträckta midja
           finns ingen storlek som passar – då säger vi hellre ingenting än fel. */
        if (hittad === -1 && stretchTak && m.hasStretch) {
          var sista = rader[rader.length - 1];
          var sistaStretch = sista ? sista.stretch : NaN;
          if (!isNaN(sistaStretch) && v > sistaStretch) forStor = true;
        }

        if (hittad === -1) hittad = rader.length - 1;
        if (hittad > maxIdx) maxIdx = hittad;
      });

      if (!nagot || maxIdx < 0 || forStor) return { index: -1, for_stor: forStor };
      return { index: maxIdx, for_stor: false };
    }

    window.onSizeCalc = { maxNum: maxNum, toInch: toInch, rekommendera: rekommendera, TUM: TUM };
  })();

(function () {
    if (window.__onFsBar) return;
    window.__onFsBar = 1;

    /* Baren satt forut sin lyssnare PER ELEMENT i connectedCallback och hade cachat
       bade sina installningar och sina inre noder. Varukorgslandan renderas om med
       morphSection i hydrerings-lage: elementet kan bytas ut eller flyttas utan att
       connectedCallback kors om, och da lag lyssnaren kvar pa ett element som inte
       langre syns - baren frok sig pa "Grattis" aven nar sista varan lag under
       troskeln. Nu ligger EN lyssnare pa document, och den letar upp baren i DOM:en
       vid varje uppdatering. Da finns ingen referens som kan bli gammal. */

    function fmt(cents, format) {
      /* NOK, PLN och EUR: landets eget sätt att skriva priser (omgång 36, on-design-tokens). */
      var loc = window.__onMoneyL ? window.__onMoneyL(cents) : null;
      if (loc !== null) return window.__onNoDec ? window.__onNoDec(loc) : loc;
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try { return Shopify.formatMoney(cents, format); } catch (e) {}
      }
      var a = cents / 100, s = a % 1 === 0 ? a.toFixed(0) : a.toFixed(2);
      var out = (format || '{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/g, s);
      return window.__onNoDec ? window.__onNoDec(out) : out;
    }

    function paint(el, total, count) {
      if (!el) return;
      /* Tom varukorg = ingen bar (Victor 12 okt 2026, fran LIVE vid sammanslagningen). */
      if (typeof count === 'number') el.hidden = count <= 0;
      if (el.hidden) return;
      /* Attributen last om varje gang: servern renderar dem med aktuella varden. */
      var threshold = parseInt(el.getAttribute('data-threshold') || '0', 10);
      var qtyMode = el.getAttribute('data-qty-mode') === 'true';
      var msg = el.querySelector('[data-fs-msg]');
      var fill = el.querySelector('[data-fs-fill]');
      var track = el.querySelector('.on-fs__track');

      if (qtyMode) {
        var tgt = parseInt(el.getAttribute('data-qty-target') || '2', 10) || 2;
        var cur = count || 0;
        var pctQ = Math.min(100, Math.round((cur / tgt) * 100));
        var remQ = Math.max(0, tgt - cur);
        if (fill) fill.style.width = pctQ + '%';
        el.classList.toggle('is-achieved', cur >= tgt);
        if (track) track.setAttribute('aria-valuenow', String(pctQ));
        if (!msg) return;
        if (cur >= tgt) msg.textContent = el.getAttribute('data-achieved') || '';
        else if (remQ === 1) msg.textContent = el.getAttribute('data-qty-one') || '';
        else msg.textContent = (el.getAttribute('data-qty-many') || '').replace('{n}', remQ);
        return;
      }

      var giftThr = parseInt(el.getAttribute('data-gift-thr') || '0', 10);
      if (giftThr && threshold) { paintTiers(el, total, threshold, giftThr, msg, fill, track); return; }

      if (!threshold) return;
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      var remaining = Math.max(0, threshold - total);
      if (fill) fill.style.width = pct + '%';
      el.classList.toggle('is-achieved', total >= threshold);
      if (track) track.setAttribute('aria-valuenow', String(pct));
      if (!msg) return;
      if (total >= threshold) {
        msg.textContent = el.getAttribute('data-achieved') || '';
      } else {
        msg.innerHTML = (el.getAttribute('data-pre') || '') + ' <strong>' +
          fmt(remaining, el.getAttribute('data-money-format') || '') + '</strong> ' +
          (el.getAttribute('data-post') || '');
      }
    }

    /* Tva nivaer (punkt 6): fri frakt och gava. Stapeln gar till den hogsta, markorerna
       visar var nivaerna ligger och texten handlar om nasta niva som inte nåtts. */
    function paintTiers(el, total, ship, gift, msg, fill, track) {
      var max = Math.max(ship, gift);
      var pct = Math.min(100, Math.round((total / max) * 100));
      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', String(pct));
      var marks = el.querySelectorAll('[data-fs-tier]');
      for (var i = 0; i < marks.length; i++) {
        var thr = marks[i].getAttribute('data-fs-tier') === 'gift' ? gift : ship;
        marks[i].classList.toggle('is-done', total >= thr);
      }
      el.classList.toggle('is-achieved', total >= max);
      el.classList.toggle('is-ship', total >= ship);
      if (!msg) return;
      /* Allt natt men gavan ligger inte i korgen (kunden tog bort den): bara fri frakt. */
      if (total >= max) { msg.textContent = el.getAttribute(el.querySelector('[data-on-gift-add]') ? 'data-achieved' : 'data-all') || ''; return; }
      var next = (total < ship && (ship <= gift || total >= gift)) ? 'ship' : 'gift';
      var nthr = next === 'ship' ? ship : gift;
      msg.innerHTML = (el.getAttribute('data-pre') || '') + ' <strong>' +
        fmt(nthr - total, el.getAttribute('data-money-format') || '') + '</strong> ' +
        (el.getAttribute(next === 'ship' ? 'data-post' : 'data-gift-post') || '');
    }

    function paintAll(total, count) {
      var bars = document.querySelectorAll('on-free-shipping');
      for (var i = 0; i < bars.length; i++) paint(bars[i], total, count);
    }

    /* Fraktforsakringen (radegenskapen _on_ins) raknas inte mot fri frakt, samma
       regel som i Liquid (snippets/on-cart-ins-sum). Utan radlista gar det inte att
       dra av den, sa da hamtas korgen. Gavan (_on_gift, 0 kr) raknas inte heller som en vara. */
    function utanForsakring(c) {
      var t = c.total_price, n = c.item_count;
      (c.items || []).forEach(function (i) {
        if (i && i.properties && (i.properties._on_ins || i.properties._on_gift)) { t -= i.final_line_price; n -= i.quantity; }
      });
      return { t: t, n: n };
    }

    var pending = false;
    function syncFromServer() {
      if (pending) return;
      pending = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { var u = utanForsakring(c); paintAll(u.t, u.n); })
        .catch(function () {})
        .then(function () { pending = false; });
    }

    function onCartUpdate(e) {
      var res = e && e.detail && e.detail.resource;
      if (res && typeof res.total_price === 'number' && Array.isArray(res.items)) {
        var u = utanForsakring(res);
        paintAll(u.t, u.n);
        return;
      }
      syncFromServer();
    }

    document.addEventListener('cart:update', onCartUpdate, true);
    document.addEventListener('cart:updated', onCartUpdate, true);
    /* Sakerhetsnat: efter en sektionsomrendering kan baren ha bytts ut mot serverns
       version, som ar renderad mot varukorgen som den sag ut FORE andringen. */
    document.addEventListener('shopify:section:load', function () { setTimeout(syncFromServer, 60); });

    /* Elementet behover ingen egen logik langre - det finns bara sa att taggen ar
       giltig och sa att en nyinsatt bar mals direkt. */
    if (!customElements.get('on-free-shipping')) {
      customElements.define('on-free-shipping', class extends HTMLElement {
        connectedCallback() { setTimeout(syncFromServer, 0); }
      });
    }
  })();
